import { render, staticRenderFns } from "./UserCoreList.vue?vue&type=template&id=60afe2ce"
import script from "./UserCoreList.vue?vue&type=script&lang=js"
export * from "./UserCoreList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports